module.exports = __webpack_public_path__ + "img/home_hero2.jpg";